import {useRef, useState} from "react"
import Text from "../../components/input/text";
import Textarea from "../../components/input/textarea";
import Button from "../../components/button";
import Alert from "../../components/alert";
import UseGetFormData from "../../hooks/UseGetFormData";
import {
    plan_features_consents_info, plan_features_limits_info, plan_features_robinson_info,
    plan_info,
    plan_limits_info
} from "../../config/tips";

import Tabs from "rc-tabs";
import TabPane from "rc-tabs/lib/TabPanelList/TabPane";
import {Archive, Info, Lock} from "react-feather";
import TabLabel from "../../components/tabLabel";
import Number from "../../components/input/number";
import Checkbox from "../../components/input/checkbox";

const Form = (props) => {
    const {plan, errors, isReady, onSubmit} = props

    const formRef = useRef()
    const infoTab = <TabLabel slug="info" label="Info" icon={<Info/>} errors={errors}/>
    const limitsTab = <TabLabel slug="limits" label="Limits" icon={<Lock/>} errors={errors}/>
    const featuresTab = <TabLabel slug="features" label="Features" icon={<Archive/>} errors={errors}/>


    const handleSubmit = (ev) => {
        ev.preventDefault()
        const FormData = UseGetFormData(formRef)
        onSubmit({
            info    : {
                name       : FormData.get('name'),
                price      : FormData.get('price'),
                description: FormData.get('description'),
            },
            features: {
                use_consents: FormData.get('use_consents'),
                use_robinson: FormData.get('use_robinson'),
            },
            limits  : {
                users        : FormData.get('users'),
                leads        : FormData.get('leads'),
                audiences    : FormData.get('audiences'),
                email_submits: FormData.get('email_submits'),
                sms_submits  : FormData.get('sms_submits'),
            },
        })
    }


    return (
        <form autoComplete="off" ref={formRef} onSubmit={handleSubmit}>
            <Tabs defaultActiveKey="0">
                <TabPane forceRender={true} key={'origin'} tabKey={'origin'} tab={infoTab}>
                    <Alert
                        icon="info"
                        docsPath="/docs/plans"
                        message={plan_info}
                    />

                    <Text required
                        size="md"
                        name="name"
                        label="Name"
                        isReady={isReady}
                        value={plan?.name}
                        placeholder="Type plan name..."
                        error={errors && errors['info.name']}
                    />


                    <Number required
                        size="md"
                        name="price"
                        label="Price"
                        isReady={isReady}
                        value={plan?.price}
                        placeholder="Type plan price..."
                        error={errors && errors['info.price']}
                    />


                    <Textarea required
                        size="md"
                        isReady={isReady}
                        name="description"
                        label="Description"
                        value={plan?.description}
                        error={errors && errors['info.description']}
                        placeholder="Type here a short description about this plan"
                    />

                </TabPane>
                <TabPane forceRender={true} key={'content'} tabKey={'content'} tab={limitsTab}>
                    <Alert
                        icon="info"
                        docsPath="/docs/plans"
                        message={plan_limits_info}
                    />

                    <Number required
                        size="md"
                        name="users"
                        isReady={isReady}
                        label="Users per account"
                        value={plan?.limits?.users}
                        placeholder="Type user limits..."
                        error={errors && errors['limits.users']}
                    />

                    <Number required
                        size="md"
                        name="leads"
                        isReady={isReady}
                        label="Leads per account"
                        value={plan?.limits?.leads}
                        placeholder="Type leads limits..."
                        error={errors && errors['limits.leads']}
                    />

                    <Number required
                        size="md"
                        name="audiences"
                        isReady={isReady}
                        label="Audiences per account"
                        value={plan?.limits?.audiences}
                        placeholder="Type audiences limits..."
                        error={errors && errors['limits.audiences']}
                    />

                    <Number required
                        size="md"
                        isReady={isReady}
                        name="sms_submits"
                        label="Monthly Sms"
                        value={plan?.limits?.sms_submits}
                        placeholder="Type monthly sms submits..."
                        error={errors && errors['limits.sms_submits']}
                    />

                    <Number required
                        size="md"
                        isReady={isReady}
                        name="email_submits"
                        label="Monthly Emails"
                        value={plan?.limits?.email_submits}
                        placeholder="Type monthly email submits..."
                        error={errors && errors['limits.email_submits']}
                    />

                </TabPane>
                <TabPane forceRender={true} key={'features'} tabKey={'features'} tab={featuresTab}>

                    <Alert
                        icon="info"
                        docsPath="/docs/plans"
                        message={plan_features_limits_info}
                    />


                    <Checkbox isReady={isReady} name="use_robinson" label="Robinson List" value={plan?.features?.use_robinson} />
                    <p className="mt-2">{plan_features_robinson_info}</p>

                    <Checkbox isReady={isReady} name="use_consents" label="Consents Manager" value={plan?.features?.use_consents} />
                    <p className="mt-2">{plan_features_consents_info}</p>
                </TabPane>
            </Tabs>

            <Button
                size="sm"
                color="primary"
                isReady={isReady}
                icon={plan ? 'check' : 'plus'}
                label={plan ? 'Update' : 'Create'}
            />

        </form>
    )
}

export default Form